/**
 * Lightweight Umami analytics wrapper.
 *
 * Umami is loaded via a <script> tag in public/index.html.
 * If the script isn't loaded (e.g. ad-blocker, missing env vars),
 * every call here is a silent no-op.
 */

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, string | number | boolean>) => void;
    };
  }
}

export function track(event: string, data?: Record<string, string | number | boolean>) {
  try {
    window.umami?.track(event, data);
  } catch {
    // never let analytics break the app
  }
}
